import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

import { COLORS } from 'pages/item/v2/components/Score/constants';
import getScoreSeverity from 'utils/get-score-severity';

import { ChartData } from './types';

interface Props {
    width: number;
    padding: number;
    chart: ChartData;
    scale?: number;
}

const LineChart: React.FC<Props> = ({ width, padding, scale, chart }) => {
    const labels = useMemo(() => chart.map(({ version }) => version), [chart]);

    const datasets = useMemo(() => {
        const data = chart.map(({ score }) => score);
        const colors = data.map((value) => COLORS.ACCENT[getScoreSeverity(value, scale)]);

        const getGradient = ({ chart }) => {
            const { ctx, chartArea } = chart;
            if (chartArea) {
                const gradient = ctx.createLinearGradient(padding, 0, width - padding, 0);
                colors.forEach((color, index) => gradient.addColorStop(index / colors.length, color));
                return gradient;
            } else {
                return null;
            }
        };

        const set = {
            data,
            fill: false,
            responsive: true,
            backgroundColor: getGradient,
            borderColor: getGradient,
            pointRadius: 0
        };
        return [set];
    }, [chart, padding, scale, width]);

    return (
        <Line
            data={{ labels, datasets }}
            options={{
                layout: { padding: padding },
                maintainAspectRatio: false,
                responsive: true,
                legend: { display: false },
                tooltips: {
                    intersect: false,
                    callbacks: {
                        title([{ label, index }]) {
                            return `Version ${label} | ${format(chart[index].published, 'yyyy-MM-dd')}`;
                        }
                    }
                },

                scales: { yAxes: [{ display: false }], xAxes: [{ display: false }] },
                title: { display: false }
            }}
        />
    );
};

export default LineChart;
